
import { Component, Mixins } from "vue-property-decorator";
import {
  IHisInformationSelectable,
  IHisInformationApplicable,
} from "../../../../../domain/document/items";
import {
  IHisInformationGroupSource,
} from "../../../../../domain/his/groupInput/HisInformationGroupSource";
import { CommonComponentsAccessor } from "../../CommonComponentsAccessor";

@Component
export default class HisInformationSelectableMixin extends Mixins() {
  editingSource: IHisInformationSelectable;
  commonComponents: CommonComponentsAccessor;

  async selectHisInformation(onSelected: (r: IHisInformationGroupSource) => Promise<boolean>): Promise<void> {
    const dialog = this.commonComponents.dialogs.hisInformation.selector;
    const result = await dialog.show(this.editingSource);
    if ((onSelected && await !onSelected(result)) || !result || (result.data === undefined)) {
      return;
    }
    await this.applySelectedInformation(this.editingSource, result);
  }

  private async applySelectedInformation(source: IHisInformationApplicable, result: IHisInformationGroupSource): Promise<void> {
    const editor = this.commonComponents.editors.hisInformation;
    await editor.applySelectedInformation(source, result);
  }
}
